import { useMemo, useState } from 'react';

import { InventoryProvider, MappingCollections } from '@scaleaq/sitecontrol-lib';

import {
  AggregatedChartConfigType,
  ChartAggregationResolution,
  ChartInterval,
  ChartType,
  ICardDataState,
  PlotType,
} from '@/components/chart/types.ts';

export const useBiomassChart = (inventoryId: string) => {
  const [chartDataStat, setChartDataStat] = useState<ICardDataState>({
    isLoading: false,
    isError: false,
    isEmpty: false,
  });

  const chartConfig: AggregatedChartConfigType = useMemo(
    () => ({
      plotType: PlotType.AGGREGATED,
      title: '', // title is not needed for non-widget charts
      type: ChartType.LIVE,
      interval: ChartInterval.Week,
      plot: [
        {
          value: MappingCollections.inventoryProviderClassPair[InventoryProvider.Biomass],
          label: '',
        },
      ],
      sensors: [{ label: '', value: inventoryId }],
      resolution: ChartAggregationResolution.DAILY,
    }),
    [inventoryId]
  );

  return { chartConfig, chartDataStat, setChartDataStat };
};
